import { render } from "./NavigationHeader.vue?vue&type=template&id=4c794278"
import script from "./NavigationHeader.vue?vue&type=script&lang=js"
export * from "./NavigationHeader.vue?vue&type=script&lang=js"

import "./NavigationHeader.vue?vue&type=style&index=0&id=4c794278&lang=css"

import exportComponent from "F:\\ssd_backup\\OpenServer\\domains\\paygate.admin-panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__